import { getCardValue } from 'utils/functions';

/**
 * Shared table/history display order: highest rank first, retaining dealt
 * order for equal ranks. Filter before sorting so the source is never mutated.
 * Only for hole cards; community cards must stay in street/deal order.
 */
export const sortHoleCards = (cards: string[]): string[] =>
  cards.filter((card) => card).sort((a, b) => getCardValue(b) - getCardValue(a));
